import React from 'react';

import { useEmployersTableListQuery } from 'src/api';
import { EmployersInnerTable } from 'src/components/employer/EmployersTable/components/EmployersInnerTable';
import { TableThemes } from 'src/components/table';
import { useFilterStorage } from 'src/hooks/common';
import { useEmployersUnderPEOPayrollProviderQueryVariables } from 'src/hooks/employer';
import { InviteEmployersByPeoPpModal } from 'src/modals/employer';

export interface PeoPayrollProviderEmployersWrapperCVAdminProps {
  peoPayrollProviderId?: string;
}

export const PeoPayrollProvidersDetailEmployersWrapper: React.FC<
  PeoPayrollProviderEmployersWrapperCVAdminProps
> = ({ peoPayrollProviderId }) => {
  const { pagination } = useFilterStorage();
  const queryVariables = useEmployersUnderPEOPayrollProviderQueryVariables(peoPayrollProviderId);

  const {
    data: employers,
    loading,
    refetch,
  } = useEmployersTableListQuery({
    variables: queryVariables,
    skip: !peoPayrollProviderId,
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const employersList = React.useMemo(() => {
    return employers?.employerList ?? [];
  }, [employers?.employerList]);

  const employersCount = React.useMemo(() => {
    return employers?.employerCount || 0;
  }, [employers?.employerCount]);

  return (
    <React.Fragment>
      <EmployersInnerTable
        employersList={employersList}
        employersCount={employersCount}
        loading={loading}
        tableTheme={TableThemes.withBorderWithoutProfileIcon}
        pagination={pagination}
        onRefresh={refetchData}
      />
      <InviteEmployersByPeoPpModal peoPayrollProviderId={peoPayrollProviderId} />
    </React.Fragment>
  );
};
